// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/service_categories/remover
 *
 * Deletes a service category by ID.
 */
import { registerContract } from './validate'

export interface ServiceCategories_RemoverInput {
so_service_category_id: number
}

registerContract('ServiceCategories_RemoverInput', {
  so_service_category_id: { type: 'number',  required: true },
})
